module.exports = __webpack_public_path__ + "img/bayviewvillageshopscom.aab0f856.png";